import { Modal } from '@mui/material';
import {Add, Person, Edit, DeleteOutline} from '@mui/icons-material';
import { Drawer ,  Dropdown  } from 'antd';
import { filter, get , map, find } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
//  -- Components ---------------------
import { Close } from '@mui/icons-material';
import ActivityForm from 'features/forms/Activity';
import { useNavigate } from "react-router-dom";
import { useActivities, useOwnGraphicOrganizers } from 'store/activities/selectors';
import { useAllBook } from 'store/books/selectors';
import { handleCreateCanvasAssignment } from 'store/canvas/thunks';
import { useClassActivities } from 'store/classActivities/selectors';
import { handleCreateClassActivity } from 'store/classActivities/thunks';
import { useCurrentClass } from 'store/classes/selectors';
import { handleCreateGoogleAssignment } from 'store/googleClassRoom/thunks';
import { useClassUsers, useUserClasses } from 'store/userClasses/selectors';
import { useCurrentUser } from 'store/users/selectors';
import color, { COLOR } from 'utils/constants/color';
import { getNumberMask } from 'utils/lib/ebookHelper';
import { validateQuizeActivityData } from 'utils/methods/createQuizeActivityValidator';
import { CaretDownOutlined } from "@ant-design/icons";
import { handleCloneCustomAssignment, handleDeleteOwnGraphicOrganizer, handleListOwnGraphicOrganizer } from 'store/activities/thunks';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { v4 } from 'uuid';
import moment from "moment";
import { handleCreateAssignmentToSchoology } from 'store/schoology/thunks';
import { graphic_activity, graphic_data } from 'utils/constants/graphic_org';
import * as Sentry from '@sentry/react';
import { useAlert } from './UI/alertSakeBar/alertProvider';
import usePopUpAtOnce from './hooks/usePopUpAtOnce';
import useBookCollection from './hooks/books/useBookCollection';
import { DeleteModal } from './Dialog';
import GraphicOrganizerEditPreview from './GraphicOrganizerEditPreview';
import useIsExamActive from './hooks/books/useIsExamActive';
import GraphicOrganizerIcon from 'utils/assets/images/GraphicOrganizerSvg.svg';
import gOrganizersButtonPng from '../utils/assets/images/g-organizers-button.png';
import grammarDrillsButtonPng from '../utils/assets/images/Grammar-drills-button.png';
import presentationButtonPng from '../utils/assets/images/presentation-button.png';
import SentryWrap from 'components/Sentry';

const LearnPlanWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent;
    overflow: hidden;
    padding:0px !important;
`;

const CloseBtn = styled.div`
    background-color: rgb(204,80,71);
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 1;
`;

const ButtonContainer = styled.div`
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 8px;
    width: 80%;
    justify-content: center;
    z-index: 1;
`;

const AssignButton = styled.button`
    background-image: linear-gradient(to right,${p => p.active ? color.greentrue : color.indigo500}, ${p => p.active ? color.greentrue : color.indigo600});
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 25px;
    color: white;
    padding: 12px;
    border-radius: 12px;
    flex: 1;
    font-size: 14px;
}
`;

const EditButton = styled.button`
    background-image: linear-gradient(to right, ${color.indigo500}, ${color.indigo600});
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    height: 25px;
    color: white;
    // padding: 12px;
    border-radius: 12px;
    font-size: 12px;
    flex: 1;
}
`;

const AssignmentPlan = styled.button`
    // background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    background-color: #020A52;
    // border: none;
    border:1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
}
`;

const AssignmentPlanInner = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction:row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;

const Items = ({ onClick = () => { }, category, assignedActivity, assignment, getNumberMask, handleDelete = () => {}, ownGraphicOrganizer = [], showAlert}) => {
    const is_assigned = assignedActivity && assignedActivity.length>0;
    const is_own_graphic_organizer = useMemo(() => {
        if (!ownGraphicOrganizer || ownGraphicOrganizer.length === 0) return false;
        const copyOfId = assignment?.copy_of?.id;
        const assignmentId = assignment?.id;
        return ownGraphicOrganizer.some(org =>
          org.graphic_org_id === copyOfId || org.graphic_org_id === assignmentId
        );
      }, [ownGraphicOrganizer, assignment]);
      
    const onNewAssign = (useCustom = false) => {
        onClick("create", assignment, useCustom)
    }
    const openAssignedAssignment = act => {
        onClick("view", act)
    }
    const handleEdit = () => {
        const matchedObj = find(graphic_activity, (obj) => obj.id == assignment.id || obj.displayName == assignment.displayName);
        const label_position = get(matchedObj, "label_position", []) || [];
        if (label_position && label_position.length > 0) {
            onClick("edit", assignment)
        } else {
            showAlert("Instructions are required to edit this assignment.", "error");
        }
    }

    const assignedAssignmentView = () => {
        return {
            items: assignedActivity && assignedActivity.length > 0 ? assignedActivity?.map((act, index) => ({
                key: index,
                label: `Assigned on page.${getNumberMask(act.assigned_on_page, act?.data?.bookId)}`,
                onClick: () => { openAssignedAssignment(act) }
            })) : [{
                key: 'assigned',
                label: 'Assigned'
            }]
        }
    }

    const assignNowMenu = () => {
        return {
            items: [
                {
                    key: 'default',
                    label: 'Use default',
                    onClick: () => onNewAssign(false)
                },
                {
                    key: 'custom',
                    label: 'Use custom',
                    onClick: () => onNewAssign(true)
                }
            ]
        }
    }
    return (<div className='myCategoryList' style={{ width: 300 }}>
        <div className="ShowDetailBnr">
            <img style={{ height: "auto" , cursor:"default" }} src={category.src} alt="" />
            {is_assigned ?
                <Dropdown
                    menu={assignedAssignmentView()}
                    trigger={['click']}>
                    <AssignButton
                        active
                        style={{ position: 'absolute', bottom: '20px', left: '50%', transform: 'translate(-50%, -50%)', width: '60%' }}
                    >
                        {`Assigned`}  <CaretDownOutlined style={{ fontSize: '18px', marginLeft: '6px', color: "#fff" }} />
                    </AssignButton>
                </Dropdown>
                : null}
            <ButtonContainer>
                {is_own_graphic_organizer ? (
                    <Dropdown
                        menu={assignNowMenu()}
                        trigger={['click']}>
                        <AssignButton>
                            Assign now <CaretDownOutlined style={{ fontSize: '14px', marginLeft: '4px' }} />
                        </AssignButton>
                    </Dropdown>
                ) : (
                    <AssignButton
                        onClick={() => onNewAssign(false)}>
                        Assign now
                    </AssignButton>
                )}
                <EditButton
                    onClick={handleEdit}>
                    <Edit style={{ fontSize: '14px' }} />
                    Edit
                </EditButton>
            </ButtonContainer>
        </div>
        <div className='categoryBtnTxt' style={{ height: "auto", paddingBottom: 10 }}>
            <div className='onway-teacher-txt' style={{ fontSize: 14, height: "auto", minHeight: 50, paddingLeft: 8 }}>
                {get(category, "description", "") || ""}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: 8, paddingRight: 8 }}>
                <div className='persionIconImg' style={{ fontSize: 8, color: "#fff" }}>
                    <Person className='iconClrChange' />
                    <span>{"ONE WAY EDUCATION"}</span>
                </div>
                {is_own_graphic_organizer && (
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: 9, color: "#fff" }}>
                        <span style={{ marginRight: 4 }}>My created</span>
                        <DeleteOutline 
                            onClick={handleDelete}
                            style={{ 
                                fontSize: '20px', 
                                color: '#fff', 
                                cursor: 'pointer',
                                opacity: 0.8
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = 1}
                            onMouseLeave={(e) => e.target.style.opacity = 0.8}
                        />
                    </div>
                )}
            </div>
        </div>
    </div>)
}
function GraphicOrganizerAssignments({ page , chapter, isResource = false }) {
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const showAlert = useAlert();
    const booksAllList = useAllBook()
    const activities = useActivities();
    const classActivities = useClassActivities();
    const {createCollectionNotification} = useCollectionNotification();
    const bookClassAssignment = useMemo(() => filter(classActivities, q => q.data?.chapter == chapter && q.data.assignment_page != null), [classActivities])
    const bookAssignment = useMemo(() => filter(activities, q => q.chapter == '7' && q.assignment_page != null && q.activity_type=='graphic_organizer'), [activities])
    const [pageModalInfo, setPageModalInfo] = React.useState({
        open: false,
        src: ''
    });
    const dispatch = useDispatch()
    const currentClass = useCurrentClass();
    const currentUser = useCurrentUser()
    const classUsers = useClassUsers();
  	const navigate = useNavigate();
    const ownGraphicOrganizer = useOwnGraphicOrganizers();
    const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);
    /** assignment area */
    const [activityDrawer, toggleActivityDrawer] = useState(false);
    const [activityData, setActivityData] = useState({});
    const [dataLoading, setDataLoading] = useState(false);
    const [durationSection, setDurationSection] = useState(false);
    const userClasses = useUserClasses()
    const [fetchSelectedRubric,setFetchRubricId] = useState(null);
    const {checkPopUpAtOnce,updatePopUpAtOnce} =  usePopUpAtOnce();
    const [graphicOrganizerEditModalOpen, setGraphicOrganizerEditModalOpen] = useState(false);
    const {nonAssignableBookIds = [], hiddenBookGroupBookId = [], hiddenBookId = []} = useBookCollection();
    const [templateType, setTemplateType] = useState(null);
    const {checkStandardExamBookType} = useIsExamActive({bookId: chapter});

    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            console.log(error, "error")
            Sentry.captureException(`219 Error during sendNotifications ${error}`);
        }
    }

    const isScheduledToday = (scheduleAt) => {
        return moment(scheduleAt).isSame(moment(), 'day');
    };

    useEffect(() => {
        if (currentUser) {
            dispatch(handleListOwnGraphicOrganizer(get(currentUser, 'id')));
        }
    }, [currentUser]);

    const createActivity = async (e) => {
        e.preventDefault();
        let studentsSelected = [];
        let actvityDataForCreate = {
            classId: currentClass.id,
            ...activityData,
            activityId: activityData.id,
            studentsSelected: studentsSelected,
            rubrics_id:  fetchSelectedRubric
        }
        const notificationData = {
            id: v4(),
            classId: get(currentClass, 'id', ''),
            displayName: get(activityData, 'displayName', ''),
            senderId: get(currentUser, 'id', ''),
            receiversId: filterClassUsers,
            modified: moment().toISOString(),
            data: {
                chapter: get(activityData, "chapter", ""),
                page: get(activityData, "page", ""),
                id: get(activityData, 'id', ''),
                scheduleAt: activityData?.scheduleAt,
            },
            message: `Your teacher Assign this Activity`,
            type: 'create_activity',
            userSeen: []
        }
        if (!actvityDataForCreate.bookId) actvityDataForCreate.bookId = activityData.chapter
        let { isValid, reason } = validateQuizeActivityData(actvityDataForCreate, "activity")
        if (!isValid) {
            setDataLoading(false);
            console.log(reason)
            return;
        }
        setDataLoading(true);
        const ownGraphicOrganizerId = find(ownGraphicOrganizer, k => k.graphic_org_id === activityData.id || k.graphic_org_id === activityData.copy_of?.id);
        const copy_of = {
            id: ownGraphicOrganizerId?.graphic_org_id,
            title: ownGraphicOrganizerId?.graphic_label || [],
            templateType: templateType
        }
        const new_activity = await dispatch(handleCloneCustomAssignment(page, chapter, activityData.id,currentUser.id, templateType === 'custom' ? ownGraphicOrganizerId?.graphic_label || [] : null, copy_of));
        if(new_activity&&new_activity.id){
            notificationData.data.id=new_activity.id;
            actvityDataForCreate.activityId=new_activity.id
        }else{
           showAlert("Something went wrong!", "error");
           setDataLoading(false);
           return;
        }
        actvityDataForCreate.studentsSelected = [];
        actvityDataForCreate.assigned_on_page = page;
        const sAssignmentData = await createAssignmetToSchoologyMultipleClass(actvityDataForCreate);
        const canvasData = await createAssignmetToCanvasMultipleClass(actvityDataForCreate);
        if (sAssignmentData && sAssignmentData.length > 0) {
            actvityDataForCreate.sAssignmentData = sAssignmentData
        }
        const googleCreateAssignment = await createAssignmentsForGoogleClassRoom(actvityDataForCreate)
        if (googleCreateAssignment && googleCreateAssignment.length > 0) {
            actvityDataForCreate.googleClassRoomAssignment = googleCreateAssignment;
        }
        if (canvasData && canvasData.length > 0) {
            actvityDataForCreate.canvasData = canvasData
        }
        await dispatch(handleCreateClassActivity(actvityDataForCreate));
        if (isScheduledToday(activityData?.scheduleAt)) {
            sendNotifications(notificationData)
        }
        toggleActivityDrawer(false);
        setDataLoading(false);
        setActivityData({});
    };
    useEffect(() => {
        if (!activityDrawer) {
            setActivityData({})
            setDataLoading(false)
            setDurationSection(false)
            setTemplateType(null)
        }
    }, [activityDrawer])

    const updateActivityData = (id, value) => {
        setActivityData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };
    const handleForDistrictAdmin = () =>{
        if (currentUser.role === 'admin') {
            showAlert('Please login as teacher!', "error");
          return true;
        }
        return false;
      }
    const handleAssignment = (type ,assignment, useCustom = false) => {
         if (nonAssignableBookIds?.includes(Number(chapter))) {
           showAlert('Book is not available for students, Assignments cannot be assign', 'info');
           return;
         } else  if(hiddenBookId?.includes(Number(chapter)) || hiddenBookGroupBookId?.includes(Number(chapter))){
           showAlert('Book is hidden, Assignments cannot be assign', 'info');
           return;
         }
        if (handleForDistrictAdmin()) return;
        if(!assignment) {
            showAlert("Some data is missing. Please reload the page.", "error");
            return;
        };
        if(type ==="create") {
            let assignmentData = { ...assignment };
            
            setTemplateType(useCustom ? 'custom' : 'default');
            
            toggleActivityDrawer(true);
            assignmentData.page = page;
            assignmentData.chapter = chapter;
            assignmentData.bookId = chapter;
            setActivityData(assignmentData);
            handleClose()
        } else if(type === "view"){
            navigate(`/ebook?chapter=${assignment?.chapter ? assignment.chapter : assignment?.data?.chapter}&page=${assignment.assigned_on_page ? assignment.assigned_on_page : assignment?.page}&activity=null&quiz=null`)
            handleClose()
        } else if(type === "edit"){
            setGraphicOrganizerEditModalOpen(true);
            setActivityData(assignment);
            // handleClose()
        }
    }
    const createAssignmentsForGoogleClassRoom = async (assignment) => {
        if (currentUser.googleId) {
            if(assignment.no_sync) return [];
            return Promise.all(map(assignment.classes, async cls => {
                const classInfo = find(userClasses, ["id", cls.id]);
                if (classInfo && classInfo.googleId) {
                    const assignmentData = currentClass.id === cls.id ? assignment : ({ ...assignment, dueDate: cls.dueDate })
                    const createdAssignment = await handleCreateGoogleAssignment(currentUser.googleId, assignmentData, classInfo.googleId)
                    return ({ classId: classInfo.id, googleAssignmentId: get(createdAssignment, "id") })
                } else {
                    return null;
                }

            })).then(v => v.filter(k => k))
        } else {
            return [];
        }
    }
    const createAssignmetToSchoologyMultipleClass = async (quizeDataforCreate) => {
        const hasClass = filter(quizeDataforCreate?.classes, (e) => e?.sectionId);
        const assignment_data = [];
        if(quizeDataforCreate.no_sync) return [];
        if (hasClass.length > 0) {
          await Promise.allSettled(
            map(hasClass, async (item) => {
              const schoologyCategory = item.schoologyCategory
                ? item.schoologyCategory
                : quizeDataforCreate.schoologyCategory;
              let data = {
                title: quizeDataforCreate.displayName,
                description: quizeDataforCreate.displayName,
                due: `${quizeDataforCreate.dueDate}`,
                type: 'assignment',
                assignees: [`${currentUser.schoologyid}`],
                grading_group_ids: [],
                grading_category: schoologyCategory,
                section_id: item.sectionId,
                classId: item.id,
                maxPoints:item.maxPoints || 100,
                factor:item.factor
              };
              assignment_data.push(data)
            })
          );
        }
        const create_data = await handleCreateAssignmentToSchoology(currentUser.schoologyid, assignment_data)
        return create_data;
      };
    const createAssignmetToCanvasMultipleClass = async (quizeDataforCreate) => {
        if (!get(currentUser, "canvas_id") || !quizeDataforCreate) return;
        if(quizeDataforCreate.no_sync) return [];
        const hasClass = map(quizeDataforCreate?.classes, e => {
            const dueDate = e.id === currentClass.id ? quizeDataforCreate.dueDate : e.dueDate
            const userClass = find(userClasses, ['id', e.id]);
            return ({
                ...e,
                class_id: e.id,
                due_date: dueDate,
                weightage: quizeDataforCreate.weightage ? quizeDataforCreate.weightage : '100',
                displayName: quizeDataforCreate.displayName,
                canvas_section_id: get(userClass, 'canvas_id'),
                canvas_course_id: get(userClass, 'canvas_course_id'),
                canvas_assignment_catrgory: e.canvas_assignment_catrgory,
                grade_type: quizeDataforCreate.grade_type,
                max_point: quizeDataforCreate.max_point,
                final_grade_exclude: quizeDataforCreate.final_grade_exclude,
                unlock_at: quizeDataforCreate?.scheduleAt
            })
        })
        const createdAssignment = await handleCreateCanvasAssignment(currentUser.canvas_id, hasClass, currentUser.canvas_auth_id)
        const result = map(createdAssignment || [], q => {
            if (q && q.canvas_course_id) {
                const classInfo = find(userClasses, uc => uc.canvas_id == q.canvas_section_id)
                return ({
                    canvas_section_id: q.canvas_section_id,
                    canvas_course_id: q.canvas_course_id,
                    canvas_assignment_id: q.id,
                    classId: get(classInfo, "id")
                })
            }
            return null;
        }).filter(q => q)
        return result;
    }
    const onCloseDrawer = () => {
        toggleActivityDrawer(false)
        setActivityData({})
        setDataLoading(false)
        setDurationSection(false)
        setTemplateType(null)
    }

    const closeGraphicOrganizerEditModal = () => {
        setGraphicOrganizerEditModalOpen(false)
        setActivityData({})
        setDataLoading(false)
        setDurationSection(false)
    }

    /** assignment area end */
    const getAssignment = useCallback((category) => {
        const assignment = find(bookAssignment, k => k.assignment_page == category.pageId);
        if (assignment) return assignment;
        const assignment_static = find(graphic_activity, k => k.assignment_page == category.pageId);
        return assignment_static;
    }, [bookAssignment])

    const deleteCustomAssignment = async () => {
        const ownGraphicOrganizerId = find(ownGraphicOrganizer, k => k.graphic_org_id === activityData.id);
        if(!ownGraphicOrganizerId) return;
        setDeleteLoading(true);
        await dispatch(handleDeleteOwnGraphicOrganizer(ownGraphicOrganizerId.id));
        setDeleteLoading(false);
        setDeleteModal(false);
    }

    useEffect(() => {
        if (pageModalInfo?.open) {
            document.documentElement.style.overflow = "hidden";
        }
        return () => {
          document.documentElement.style.overflow = "auto";
          document.body.style.overflow = "auto";
        };
      }, []);

    const getNumberMaskText = (page_id, book_id)=>{
        return getNumberMask(book_id, page_id, booksAllList)
    }
    const handleOpen = (item) => {
        if(checkPopUpAtOnce()){
            return;
        }
        setPageModalInfo({
            open: true,
        })
        updatePopUpAtOnce(true);
        dispatch(handleListOwnGraphicOrganizer(get(currentUser, 'id')));
    };
    const handleClose = () => {setPageModalInfo({
        open: false,
        src: ''
    })
       updatePopUpAtOnce(false);
};
    return (
        <SentryWrap>
            <DeleteModal
                message={`Are you sure you want to delete? You will lose all submissions and grades for this assignment.`}
                deleteToggle={deleteModal}
                setDeleteToggle={setDeleteModal}
                loading={deleteLoading}
                onDelete={deleteCustomAssignment}
            />
            <Drawer
                height='100%'
                destroyOnHidden
                onClose={onCloseDrawer}
                placement='top'
                open={activityDrawer}
                key='activityNew'
                className='assignments-drawer'
            >
                <>
                    <ActivityForm
                        data={activityData}
                        handleChange={e => updateActivityData(e.target.id, e.target.value)}
                        handleSubmit={createActivity}
                        setDurationSection={setDurationSection}
                        durationSection={durationSection}
                        onClose={() => toggleActivityDrawer(false)}
                        loading={dataLoading}
                        handleRubric={(value)=> {
                          setFetchRubricId(value?.id || "")
                        }}
                        setTemplateType={setTemplateType}
                    />
                </>
            </Drawer>
            <Modal
                open={pageModalInfo.open}
                onClose={handleClose}
                className={"rubricsPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
                onContextMenu={e => {
                    e.preventDefault();
                }}
            >
                <LearnPlanWrapper className='teacherStrategies'>
                    <CloseBtn onClick={handleClose}>
                        <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }} />
                    </CloseBtn>
                    <div className='myCategorys' style={{ height: "95vh", overflow: "auto", alignItems: "center", marginTop: 0 }}>
                        {graphic_data.map((category, index) => (<Items
                            category={category}
                            key={index + "_cat"}
                            onClick={handleAssignment}
                            handleDelete={() => {
                                setDeleteModal(true);
                                setActivityData(getAssignment(category));
                            }}
                            assignedActivity={filter(bookClassAssignment,k=>k.data.assignment_page == category.pageId)}
                            assignment={getAssignment(category)}
                            getNumberMask={getNumberMaskText}
                            ownGraphicOrganizer={ownGraphicOrganizer}
                            showAlert={showAlert}
                        />))}
                    </div>

                </LearnPlanWrapper>
            </Modal>
            <Modal
                open={graphicOrganizerEditModalOpen}
                onClose={closeGraphicOrganizerEditModal}
                className={"rubricsPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
                onContextMenu={e => {
                    e.preventDefault();
                }}
            >
                <GraphicOrganizerEditPreview
                    open={graphicOrganizerEditModalOpen}
                    setOpen={setGraphicOrganizerEditModalOpen}
                    assignment={activityData}
                    ownGraphicOrganizer={ownGraphicOrganizer}
                />
            </Modal>
            {/* <ContollButton onClick={() => handleOpen()}>Graphic Organizers</ContollButton> */}
            {isResource ? (
                <button className="addOneImg graphicOrgRsource" onClick={() => handleOpen()}>
                  <img src={GraphicOrganizerIcon} alt="Graphic organizers" title="Graphic organizers" />
                </button>   
            ) : (
                !checkStandardExamBookType && (
            <AssignmentPlan
                className='ebooks-button'
                onClick={() => handleOpen()}
            >
                <AssignmentPlanInner>Graphic organizers</AssignmentPlanInner>
            </AssignmentPlan>
            )
            )}
            {/* <div className='gameStudyCollect 11'>
            <div className='graphicOrg graphicOrgBtn addOneImg' onClick={() => handleOpen()}>
                <img src={gOrganizersButtonPng} alt="Graphic organizers" title="Graphic organizers" />
            </div> */}
            {/* 
            <div className='graphicOrg addOneImg'>
                <img src={grammarDrillsButtonPng} alt="" />
            </div>

            <div className='graphicOrg addOneImg' onClick={() => handleOpen()}>
                <img src={presentationButtonPng} alt="Presentation" title="Presentation" />
            </div> */}
            {/* </div> */}


        </SentryWrap>
    )
}

export default GraphicOrganizerAssignments;